export const missionKeys = {
  all: ["mission"] as const,
  mission: (missionId: string) => [...missionKeys.all, missionId] as const,
  project: (projectId: string) => [...missionKeys.all, projectId, "project"] as const,
};
